module.exports = __webpack_public_path__ + "static/img/charm_level_90.308c887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_90.png
// module id = tfRs
// module chunks = 0